<template>
  <v-main>
    <v-container fluid grid-list-md >
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Nominations")}}</h1>
        </v-flex>
        <!-- Search Filters -->
        <v-flex xs12>
          <v-layout row wrap>
          <v-flex xs2 shrink><v-select outlined dense hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          <v-flex xs2 shrink><v-autocomplete outlined dense hide-details="true" :items="agreements" v-model="agreementId" item-value="Id" @change="agreementChanged" :item-text="i => i.No + '  ' + i.Name" :label="$t('Agreement')" :no-data-text="ct.NoDataAvailable"></v-autocomplete></v-flex>
          <v-flex xs2 shrink><v-autocomplete outlined dense hide-details="true" :items="customers" v-model="customerNo" item-value="No" @change="customerChanged" :item-text="i => i.No + ' ' + i.Name" :label="$t('Customer')" :no-data-text="ct.NoDataAvailable"></v-autocomplete></v-flex>
          <v-flex xs2 shrink><v-select outlined dense hide-details="true" :items="wasteFuelTypes" v-model="wasteFuelType" item-value="value" @change="wasteFuelTypeChanged" :item-text="i => i.text" :label="$t('Waste/Fuel')"></v-select></v-flex>
          <v-flex xs2 shrink><v-select outlined dense hide-details="true" :items="plants" v-model="plantNo" item-value="No" @change="plantChanged" :item-text="i => i.No + ' ' + i.Name" :label="$t('Plant')" :no-data-text="ct.NoDataAvailable"></v-select></v-flex>
          <v-flex xs2 shrink></v-flex>
          </v-layout>
          <v-row>
          </v-row>
        </v-flex>
     </v-layout>
      <v-layout row wrap>
        <!-- Search Filters -->
        <v-flex xs12>
          <v-layout row wrap>
          <v-flex xs2 shrink><DatePicker v-model="DateFrom" label="Start date"></DatePicker></v-flex>
          <v-flex xs2 shrink><DatePicker v-model="DateTo" label="End date"></DatePicker></v-flex>
          <v-flex xs2 shrink><v-select outlined dense class="mt-1" hide-details="true" :items="viewTypes" v-model="viewType" @change="viewChanged" :item-text="i => $t(i.text)" :label="$t('View')"></v-select></v-flex>
          <v-flex xs2 shrink></v-flex>
          <!-- <v-flex xs2 shrink><v-select outlined dense class="mt-1" hide-details="true" :items="activeTypes" v-model="activeType" @change="activeTypeChanged" :item-text="i => $t(i.text)" :label="$t('Agreement') + ' ' + $t('Active')"></v-select></v-flex> -->
          <v-flex xs2 shrink><v-select outlined dense class="mt-1" hide-details="true" :items="states" v-model="stateNo" @change="stateChanged" :item-text="i => $t(i.text)" :label="$t('State')"></v-select></v-flex>
          <v-flex xs1 shrink></v-flex>
          <!-- Search and Save buttons and Live Filters -->
          <v-btn class="ml-1 mt-3 mr-4" min-width="140px" :loading="loading" color="primary" @click="searchClicked"><v-icon>search</v-icon>{{$t('Search')}}</v-btn>
          <v-btn v-if="nominations.length" class="ml-1 mt-3 mr-4" :disabled="!changes" min-width="140px" color="success" @click="saveClicked"><v-icon>save</v-icon>{{$t('Save') + dirtyDays()}}</v-btn>
          <v-checkbox v-if="nominations.length" :label="$t('Edit mode')" class="mt-3 ml-10 mr-10" v-model="editMode" @click.native.prevent.stop.capture="askEditModeDialog($event)" :color="'primary'"></v-checkbox>
          <!-- <v-flex v-if="nominations.length" xs2 shrink><v-select outlined dense class="mt-1" hide-details="true" :items="viewTypes" v-model="viewType" @change="viewChanged" :item-text="i => $t(i.text)" :label="$t('View')"></v-select></v-flex> -->
          <v-checkbox v-if="nominations.length" :label="$t('Send emails on save')" class="mt-3 ml-10 mr-10" v-model="sendEmails" :color="'primary'"></v-checkbox>
          </v-layout>
          <v-row>
          </v-row>
        </v-flex>
        <!-- Status Results -->
        <v-flex xs12>
          <h3 class="mt-n2 mb-n5" v-if="nominations.length">{{$t("Agreements found")}}: {{nominations.length}} {{weeks}}</h3>
          <h3 class="mt-1" v-else>{{$t("Agreements found")}}: {{nominations.length}}</h3>
        </v-flex>
     </v-layout>
     <v-progress-linear class="mt-n4" v-if="loading" :indeterminate="true"></v-progress-linear>
     <v-flex class="mt-3" xs12 v-else>
     <div v-for="nomination in orderedNominations" :key="nomination.id">
        <!-- Nomination agreement header and buttons -->
        <v-flex xs12 class="mt-8">
          <v-layout row wrap>
            <v-flex xs6>
              <v-flex class="mt-n2"><h3>{{$t("Agreement")}} {{ agreementNoName(nomination.id) }}</h3></v-flex>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex grow></v-flex>
                <v-btn class="mt-n2" color="success" v-if="!isCustomer" @click="autofillRequestedClicked(nomination.period)"><v-icon>auto_fix_normal</v-icon>{{$t('Autofill')}}</v-btn>
                <v-btn class="mt-n2 ml-2" color="white" @click="loadAndShowLogs(nomination.id)"><v-icon></v-icon>{{$t('Logs')}}</v-btn>
                <v-btn class="mt-n2 ml-2" color="white" @click="loadAndShowDetails(nomination.id, nomination.period)"><v-icon></v-icon>{{$t('Details')}}</v-btn>
                <v-btn class="mt-n2 ml-2" color="success" v-if="isCustomer" :disabled="isNominationDirty(nomination.id)" @click="acceptRequestsClicked(nomination.period)"><v-icon>check</v-icon>{{$t('Requested')}}</v-btn>
                <v-btn class="mt-n2 ml-2 mr-1" color="success" v-if="!isCustomer" :disabled="isNominationDirty(nomination.id)" @click="acceptResponsesClicked(nomination.period)"><v-icon>check</v-icon>{{$t('Response')}}</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Nomination period details -->
        <v-flex xs12 row>
          <v-flex xs11>
            <v-layout row wrap class="mt-3 mb-0 ml-3 mr-3">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <td class="my-td"></td>
                        <th v-for="header in nomination.period.filter(n => n.amountType === 0 && (viewType==='0' || viewType==='1' && n.dateType==1) )" :key="header.id">
                          <td class="my-td" :style="headerColor(header)">{{ header.dateType === 0 ? formatDateShort(header.nomDate) : formatDateWeekOnly(header.nomDate) }}</td>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- ROWS Agreed, Requested, Response, Delivered -->
                      <tr v-for="row in amountTypes" :key="row.amountType">
                        <td class="my-td" style="font-weight:bold">{{ $t(row.text) }}</td>
                        <!-- ROW Days/Weekes -->
                        <td class="my-td" v-for="item in nomination.period.filter(n => n.amountType === row.amountType && (viewType==='0' || viewType==='1' && n.dateType==1))" :key="item.id">
                          <v-text-field v-if="editMode"
                            :class="amountColor(row.amountType, item.dateType)"
                            :disabled="(item.amountType === 0) || (item.amountType === 3) || isPast(item.nomDate) || (isCustomer ? item.amountType === 1 : false)"
                            v-model="item.value"
                            type="number"
                            min="0"
                            step="1"
                            hide-details="true"
                            dense
                            @change="amountChanged(item, nomination.period)"
                          />
                          <div v-else :class="'value-div' + (item.dateType === 1  ? ' comment-div' : '')">{{ item.value ? item.value : '0' }}</div>
                        </td>
                      </tr>
                      <!-- ROW Comments span 8 cols on days view and span 1 col on weeks view -->
                      <td class="my-td" style="font-weight:bold">{{ $t('Comments') }}</td>
                      <!-- ROW Weeks Comments -->
                      <td class="my-td" v-for="item in nomination.period.filter(n => n.amountType === 0 && (n.dateType==1))" :key="item.id" :colspan="viewType==='0' ? 8 : 1">
                        <v-textarea v-if="editMode"
                            class="mt-1 mb-1"
                            outlined dense
                            auto-grow
                            rows="1"
                            v-model="item.comment"
                            hide-details="true"
                            @change="commentChanged(item)"
                        />
                        <div v-else class="comment-div">{{ item.comment }}</div>
                      </td>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-layout>
            </v-flex>

          <!-- Rows sums -->
            <v-flex xs1>
              <v-layout row wrap class="mt-4 ml-3">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>
                        <td class="my-td" style="font-weight:bold; color:black">{{ $t('Sum') }}</td>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in amountTypes" :key="row.amountType">
                        <td class="my-td">
                            <v-text-field v-if="editMode"
                              :class="amountColor(row.amountType, 1)"
                              disabled
                              :value="rowSum(nomination.id, row.amountType)"
                              type="number"
                              min="0"
                              step="1"
                              hide-details="true"
                              dense
                            />
                            <div v-else class="amount-field-week">{{ rowSum(nomination.id, row.amountType) }}</div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-layout>
            </v-flex>
          </v-flex>
        </div>
      </v-flex>
     <!-- Sums for all agreements (use only index=0 in agreements for sums) -->
     <div v-for="(nomination, index) in cSums" :key="nomination.id">
      <div v-if="!loading && nominations.length && index === 0">
        <v-flex xs12 row>
          <v-flex xs11>
          <!-- Sums header -->
          <v-flex xs12 class="mt-12">
            <v-layout row wrap>
              <v-flex xs6>
                <v-flex class="mt-n2 ml-3"><h3>{{ $t('Sums for this search') }}</h3></v-flex>
              </v-flex>
              <v-flex xs6>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- Sums period details -->
          <!-- <v-card raised class="mb-6 mt-3"> -->
            <v-layout row wrap class="mb-0 ml-3 mr-3">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <td class="my-td"></td>
                      <th v-for="header in nomination.period.filter(n => n.amountType === 0 && (viewType==='0' || viewType==='1' && n.dateType==1) )" :key="header.id">
                        <td class="my-td" :style="headerColor(header)">{{ header.dateType === 0 ? formatDateShort(header.nomDate) : formatDateWeekOnly(header.nomDate) }}</td>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- ROWS Sum -->
                    <tr v-for="row in amountTypes" :key="row.amountType">
                      <td class="my-td" style="font-weight:bold; min-width:85px">{{ $t(row.text) }}</td>
                      <!-- ROW Sums -->
                      <td class="my-td" v-for="item in nomination.period.filter(n => n.amountType === row.amountType && (viewType==='0' || viewType==='1' && n.dateType==1))" :key="item.id">
                        <v-text-field v-if="editMode"
                          :class="sumColor(row.amountType)"
                          disabled
                          :value="item.value"
                          type="number"
                          hide-details="true"
                          dense
                        />
                        <div v-else class="comment-div">{{ item.value ? item.value : 0 }}</div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-layout>
            </v-flex>
          </v-flex>
        </div>
      </div>

      <!-- Bottom Save button -->
      <v-btn v-if="nominations.length" class="mt-7" min-width="150px" color="success" @click="saveClicked" :disabled="!changes"><v-icon>save</v-icon>{{$t("Save") + (changes ? '* (' + changes + ')' : '')}}</v-btn>
    </v-container>

    <!-- Edit Mode dialog warning -->
    <v-dialog
      v-model="showEditModeDialog" max-width="300">
      <v-card>
        <v-card-title class="headline">{{$t("Edit mode warning")}}</v-card-title>
        <v-card-text>{{$t("Are you sure you want simultaneous to edit")}} {{nominations.length}} {{nominations.length > 1 ? $t("Nominations") : $t("Nomination")}}?</v-card-text>
        <v-card-text>{{weeks}}</v-card-text>
        <v-card-text>{{$t("This will take some time to enable.")}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="showEditModeDialog=false; editMode=true">{{$t("Yes")}}</v-btn>
          <v-btn color="success" @click.native="showEditModeDialog=false">{{$t("No")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Details dialog -->
    <v-dialog
      v-model="showAgreementDetailsDialog" max-width="450">
      <v-card>
        <div v-if="agreementDetailsLines">
          <v-card-title class="headline">{{ agreementHeadline }}</v-card-title>
          <h4 class="ml-6 mr-6" v-for="detail in agreementDetailsLines" :key="detail.No" name="agreementDetailsLines">{{detail.Text}}<br></h4>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="agreementDetailsLines=[]; showAgreementDetailsDialog=false">{{$t("Ok")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Logs dialog -->
    <v-dialog
      v-model="showAgreementLog" max-width="1250" >
      <v-card>
        <div>
          <v-card-title class="headline ml-2" v-text="$t('Logs')"></v-card-title>
          <!-- :items-per-page="10" -->
          <v-flex xs12 class="ml-6 mr-6">
            <v-data-table dense
              :headers="translatedHeaders()"
              :items="agreementLogs"
              :items-per-page="5"
              class="elevation-1">
                <template v-slot:[`item.ChangedDate`]="{ item }">
                  {{ datetime(item.ChangedDate) }}
                </template>
                <template v-slot:[`item.AmountType`]="{ item }">
                  {{ amountTypeText(item) }}
                </template>
                <template v-slot:[`item.NomDate`]="{ item }">
                  {{ date(item) }}
                </template>
                <template v-slot:[`item.AmountBefore`]="{ item }">
                  {{ before(item) }}
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  {{ after(item) }}
                </template>
                <template v-slot:[`item.ChangedBy`]="{ item }">
                  {{ item.ChangedBy }}
                </template>
                <template v-slot:[`item.Notes`]="{ item }">
                  {{ item.Notes }}
                </template>
            </v-data-table>
          </v-flex>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" color="success" @click.native="agreementLogs=[]; showAgreementLog=false">{{$t("Ok")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
import ct from '@/core/mixins/common-translations'
import formatDate from '@/core/mixins/formatDate'
import * as DateUtil from '@/core/date'
import moment from 'moment'
import DatePicker from '@/core/components/DatePicker'
import * as Nomination from '@/modules/nomination/nomination'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as Utils from '@/core/utils'
import _ from 'lodash' // _.orderBy() sorting tool for Nominations Number ordering (alphanummeric-nummeric)
import { user } from '@/core/security'

const daysInPeriod = 4 * 7 // Default start with 4 weeks interval from week of today
const guidEmpty = '00000000-0000-0000-0000-000000000000'

export default {
  mixins: [ct, formatDate, DateUtil],
  components: { DatePicker },
  data: () => ({
    loading: false,
    changes: 0,
    editMode: false,
    sendEmails: true, // default always send emails - posibility to skip sending when ex. only saving drafts
    showEditModeDialog: false,
    showAgreementDetailsDialog: false,
    agreementHeadline: '',
    agreementDetailsLines: [],
    showAgreementLog: false,
    logHeaders: [
      { text: 'Date', value: 'ChangedDate' },
      { text: 'Change', value: 'AmountType' },
      { text: 'Day/Week', value: 'NomDate' },
      { text: 'Before', value: 'AmountBefore' },
      { text: 'After', value: 'Amount' },
      { text: 'User', value: 'ChangedBy' },
      { text: 'Notes', value: 'Notes' }
    ],
    agreementLogs: [],
    registrations: [],
    nominations: [],
    amountTypes: [
      { amountType: 0, text: 'Agreed' },
      { amountType: 1, text: 'Requested' },
      { amountType: 2, text: 'Response' },
      { amountType: 3, text: 'Delivered' }
    ],
    facilityNo: '',
    facilities: [],
    facilitiesDescription: [],
    facilityDescription: '',
    useFacilityDescription: false,
    facilityDisplay: '',
    facilitiesDisplay: [],
    agreementId: guidEmpty,
    agreements: [],
    customerNo: '',
    customers: [],
    wasteFuelType: '',
    wasteFuelTypes: [],
    plantNo: '',
    plants: [],
    // DateFrom always starts on mondays of current week
    DateFrom: moment().subtract(moment().day() === 0 ? 6 : moment().day() - 1, 'days').format('YYYY-MM-DD'),
    // DateTo always ends on sundays in relevant week
    DateTo: moment(moment().subtract(moment().day() === 0 ? 6 : moment().day() - 1, 'days').format('YYYY-MM-DD')).add(daysInPeriod - 1, 'days').format('YYYY-MM-DD'),
    DateFromMonday: null,
    DateToSunday: null,
    viewType: '0',
    viewTypes: [
      { value: '0', text: 'Days' },
      { value: '1', text: 'Weeks' }
    ],
    activeType: '1', // Always only show active Agreements (non-deleted)
    stateNo: '',
    states: [
      { value: '', text: '' },
      { value: '1', text: 'Agreed' },
      { value: '2', text: 'Unagreed' }
    ],
    isCustomer: false,
    sumTimer: null,
    rSums: [], // placeholder for all Row Sums pr. agreement
    cSums: [] // placeholder for all Total Column Sums pr. row type
  }),
  computed: {
    uniqueAgreements () {
      // Caculate unique Agreement ids fom loaded Nomination registrations used in mergeNominationRegistrations()
      return [...new Set(this.registrations.map(r => r.AgreementId))]
    },
    weeks () {
      // Caculate how many weeks between from and to date. Just a nice helper info.
      return this.$t('Weeks') + ': ' + (moment(this.DateTo).diff(moment(this.DateFrom), 'week') + 1)
    },
    orderedNominations () {
      // Agreement number (no field) memory (clientside) sorting Nominations correctly by alphanumeric numbers (20 char 0 padded). Easy to change later.
      return _.orderBy(this.nominations, 'no') // _.orderBy comes from the lodash module
    }
  },
  methods: {
    datetime (date) {
      return DateUtil.getDateTimeYMDT(date)
    },
    amountTypeText (item) {
      if (item.AmountType === 0 && item.DateType === 1 && item.AmountBefore === item.Amount && item.Comment) {
        return this.$t('Comment')
      }
      return this.$t(this.amountTypes.find(a => a.amountType === item.AmountType).text)
    },
    before (item) {
      if (item.AmountType === 0 && item.DateType === 1 && item.AmountBefore === item.Amount && item.Comment) {
        return item.CommentBefore
      }
      return Math.round(item.AmountBefore / 1000, 0) // Nomination Log Amounts are always saved in Kg in DB and converted to Tons
    },
    after (item) {
      if (item.AmountType === 0 && item.DateType === 1 && item.AmountBefore === item.Amount && item.Comment) {
        return item.Comment
      }
      return Math.round(item.Amount / 1000, 0) // Nomination Log Amounts are always saved in Kg in DB and converted to Tons
    },
    date (item) {
      return item.DateType === 1 ? this.$t('Week') + ' ' + moment(item.NomDate).isoWeek() : DateUtil.getDateTimeYMD(item.NomDate)
    },
    translatedHeaders () {
      return this.logHeaders.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },

    async loadAndShowDetails (id, period) {
      this.agreementHeadline = this.$t('About') + ' ' + this.agreementNoName(id)
      var customerNos = []
      var articleNos = []
      var plantNos = []
      var deliveryCount = 0
      const agreementNo = this.agreements.find(a => a.Id === id).No
      const res = await Nomination.loadAgreementAndDetails({ Facility: this.facilityNo, AgreementNo: agreementNo })
      if (!res.failed && res.data) {
        res.data.Details.forEach(detail => {
          if (detail.Name === 'CustomerNo') {
            if (detail.Name === 'CustomerNo' && detail.Value) { customerNos.push(detail.Value) }
            if (detail.Name === 'ArticleNo' && detail.Value && !articleNos.includes(detail.Value)) { articleNos.push(detail.Value) }
            if (detail.Name === 'PlantNo' && detail.Value && !plantNos.includes(detail.Value)) { plantNos.push(detail.Value) }
          }
        })
        res.data.Deliveries.forEach(delivery => {
          deliveryCount += 1
          delivery.Details.forEach(detail => {
            if (detail.Name === 'DelArticleNo' && detail.Value && !articleNos.includes(detail.Value)) { articleNos.push(detail.Value) }
            if (detail.Name === 'DelPlantNo' && detail.Value && !plantNos.includes(detail.Value)) { plantNos.push(detail.Value) }
          })
        })

        // calculate period totals (in memory)
        var agreedWeeksTotals = 0
        var agreedDaysTotals = 0
        var deliveredDaysTotals = 0
        period.filter(p => p.amountType === 0 && p.dateType === 1).forEach(p => { agreedWeeksTotals += Number(p.value ?? 0) })
        if (this.viewType === '0') period.filter(p => p.amountType === 0 && p.dateType === 0).forEach(p => { agreedDaysTotals += Number(p.value ?? 0) })
        period.filter(p => p.amountType === 3 && p.dateType === 0).forEach(p => { deliveredDaysTotals += Number(p.value ?? 0) })

        // create all agreementDetailsLines
        var number = 0
        this.agreementDetailsLines = []
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('Agreed period sum (weeks)') + ': ' + agreedWeeksTotals })
        if (this.viewType === '0') this.agreementDetailsLines.push({ No: number++, Text: this.$t('Agreed period sum (days)') + ': ' + agreedDaysTotals })
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('Delivered period sum (days)') + ': ' + deliveredDaysTotals })
        this.agreementDetailsLines.push({ No: number++, Text: '' })
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('CustomerNo') + ': ' + customerNos.join(', ') })
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('Deliveries') + ': ' + deliveryCount })
        this.agreementDetailsLines.push({ No: number++, Text: '' })
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('ArticleNo') + ': ' + articleNos.join(', ') })
        this.agreementDetailsLines.push({ No: number++, Text: '' })
        this.agreementDetailsLines.push({ No: number++, Text: this.$t('PlantNo') + ': ' + plantNos.join(', ') })

        // show dialog with agreement details
        this.showAgreementDetailsDialog = true
      }
    },
    async loadAndShowLogs (id) {
      this.agreementLogs = []
      const res = await Nomination.loadAgreementLog({ AgreementId: id })
      if (!res.failed && res.data) {
        this.agreementLogs = res.data
        // show dialog with agreement logs
        this.showAgreementLog = true
      }
    },
    agreementNoName (id) {
      const agreement = this.agreements.find(a => a.Id === id)
      return agreement ? agreement.No + ' ' + agreement.Name : '{' + id + '}'
    },
    agreementNo (id) {
      // Sorting Nominations correctly by alphanumeric numbers (20 char 0 padded)
      const agreement = this.agreements.find(a => a.Id === id)
      return agreement ? agreement.No.padStart(20, '0') : '00000000000000000000'
    },
    saveClicked () {
      this.saveNominationRegistrations()
    },
    async searchClicked () {
      await this.loadAgreements()
      await this.loadNominationRegistrations()
    },
    autofillRequestedClicked (nominationPeriod) {
      const today = moment().format('YYYY-MM-DD')
      let firstValue = 'x'
      // Change all request values to first day/week value
      nominationPeriod.filter(n => n.amountType === 1 && (n.dateType === Number(this.viewType)) && moment(n.nomDate).format('YYYY-MM-DD') >= today).forEach(item => {
        if (firstValue === 'x') {
          firstValue = nominationPeriod.find(n => n.amountType === 1 && n.dateType === item.dateType && n.nomDate === item.nomDate).value
        } else if (firstValue !== 'x') {
          item.value = firstValue; item.dirty = true; this.changes++
        }
      })
      // Force calculate row and column sums
      this.calculateSums()
    },
    acceptRequestsClicked (nominationPeriod) {
      const today = moment().format('YYYY-MM-DD')
      // Accept all request values in selected period (not in past) for days+week or just week depending on viewType
      nominationPeriod.filter(n => n.amountType === 1 && (this.viewType === '0' || (this.viewType === '1' && n.dateType === 1))).forEach(item => {
        if (item.value) {
          const accept = nominationPeriod.find(n => n.amountType === 0 && n.dateType === item.dateType && n.nomDate === item.nomDate && moment(n.nomDate).format('YYYY-MM-DD') >= today)
          if (accept) {
            accept.value = item.value; accept.dirty = true; this.changes++
            item.value = ''; item.dirty = true
            const response = nominationPeriod.find(n => n.amountType === 2 && n.dateType === item.dateType && n.nomDate === item.nomDate && moment(n.nomDate).format('YYYY-MM-DD') >= today)
            if (response.value) { response.value = ''; response.dirty = true; this.changes++ }
          }
        }
      })
      // Force calculate row and column sums
      this.calculateSums()
    },
    acceptResponsesClicked (nominationPeriod) {
      const today = moment().format('YYYY-MM-DD')
      // Accept all response values in selected period (not in past) for days+week or just week depending on viewType
      nominationPeriod.filter(n => n.amountType === 2 && (this.viewType === '0' || (this.viewType === '1' && n.dateType === 1))).forEach(item => {
        if (item.value) {
          const accept = nominationPeriod.find(n => n.amountType === 0 && n.dateType === item.dateType && n.nomDate === item.nomDate && moment(n.nomDate).format('YYYY-MM-DD') >= today)
          if (accept) {
            accept.value = item.value; accept.dirty = true; this.changes++
            item.value = ''; item.dirty = true
            const request = nominationPeriod.find(n => n.amountType === 1 && n.dateType === item.dateType && n.nomDate === item.nomDate && moment(n.nomDate).format('YYYY-MM-DD') >= today)
            if (request.value) { request.value = ''; request.dirty = true; this.changes++ }
          }
        }
      })
      // Force calculate row and column sums
      this.calculateSums()
    },
    facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      LocalStorage.save('facilityNo', this.facilityNo)
      // reset other filters and clear nomination periods
      this.nominations = []
      this.agreementId = guidEmpty
      this.customerNo = ''
      this.wasteFuelType = ''
      this.plantNo = ''
      this.activeType = '1' // Always only show active Agreements (non-deleted)
      this.stateNo = ''
      this.loadAgreements()
      this.loadAgreementCustomers()
      this.loadAgreementPlants()
      this.loadWasteFuelTypes()
    },
    agreementChanged () {
      LocalStorage.save('agreementId', this.agreementId)
      // clear nomination periods
      this.nominations = []
    },
    customerChanged () {
      LocalStorage.save('customerNo', this.customerNo)
    },
    wasteFuelTypeChanged () {
      LocalStorage.save('wasteFuelType', this.wasteFuelType)
    },
    plantChanged () {
      LocalStorage.save('plantNo', this.plantNo)
    },
    stateChanged () {
      LocalStorage.save('stateNo', this.stateNo)
    },
    viewChanged () {
      // Force calculate row and column sums
      this.calculateSums()
    },
    askEditModeDialog (event) {
      // if more than 50 edit controls will be created, ask the user
      if (!this.editMode && (this.nominations.length * (moment(this.DateTo).diff(moment(this.DateFrom), 'week') + 1) > 50)) {
        this.showEditModeDialog = true
      } else this.editMode = !this.editMode
    },
    headerColor (header) {
      // Show headers as grey (past), blue (today) or future (black)
      var color = header.dateType === 0 && header.nomDate.toDateString() === new Date().toDateString() ? 'color:blue'
        : (header.dateType === 0 && this.isPast(header.nomDate)) ? 'color:lightgrey'
          : 'color:black'
      return color
    },
    amountColor (row, dateType) {
      // When in Edit mode let amount fields be different colored (blue (days), black)
      var color = 'amount-field' // Blueish frame for weekdays
      if (dateType === 1) color = 'amount-field-week' // Blackish frame for weeks
      if (row === 0) { color += ' my-green' } // Agreed green text
      if (row === 1 || row === 2) { color += ' my-red' } // Requested+Response red text
      if (row === 3) { color += ' my-black' } // Delivered black text
      return color
    },
    sumColor (row) {
      var color = 'amount-field-week' // Blueish frame for weekdays
      if (row === 0) { color += ' my-green' } // Agreed green text
      if (row === 1 || row === 2) { color += ' my-red' } // Requested+Response red text
      if (row === 3) { color += ' my-black' } // Delivered black text
      return color
    },
    isNominationDirty (id) {
      return this.nominations.find(n => n.id === id).period.some(p => p.dirty)
    },
    dirtyDays () {
      var daysCount = 0
      this.nominations.forEach(nom => {
        daysCount +=
        _.uniqBy(nom.period.filter(p => p.dirty && p.dateType === 0), 'nomDate').length +
        _.uniqBy(nom.period.filter(p => p.dirty && p.dateType === 1), 'nomDate').length
      })
      return daysCount > 0 ? '* (' + daysCount + ')' : ''
    },
    amountChanged (item, nominationPeriod) {
      // If same decimal value in Requested and Responce always move values to Agreed
      const oppositeNominationType = item.amountType === 1 ? 2 : 1
      const oppositeNomination = nominationPeriod.find(n => n.amountType === oppositeNominationType && n.dateType === item.dateType && ((n.nomDate && n.nomDate === item.nomDate)))
      if (Math.abs(item.value - oppositeNomination.value) < 0.001) {
        const agreedNomination = nominationPeriod.find(n => n.amountType === 0 && n.dateType === item.dateType && ((n.nomDate && n.nomDate === item.nomDate)))
        agreedNomination.value = item.value
        agreedNomination.dirty = true
        item.value = ''
        item.dirty = true
        oppositeNomination.value = ''
        oppositeNomination.dirty = true
        this.dirty = true
      }

      // Force calculate row and column sums
      this.calculateSums()
      this.changes++
      item.dirty = true
    },
    commentChanged (item) {
      this.changes++
      item.dirty = true
    },
    isPast (val) {
      return val.valueOf() <= new Date().setHours(0, 0, 0, 0).valueOf()
    },
    async saveNominationRegistrations () {
      const regs = []
      let reload = false
      this.nominations.forEach(nomination => {
        nomination.period.forEach(period => {
          if (period.dirty) {
            // Set Id to new Id (if id is just a dummy number) or use Id from db
            const realId = Utils.isNumber(period.id) ? guidEmpty : period.id
            // Reload any created Id's from db, so later saves always works
            if (realId === guidEmpty) reload = true
            regs.push(
              {
                Id: realId,
                AgreementId: nomination.id,
                AmountType: period.amountType,
                DateType: period.dateType,
                NomDate: period.nomDate,
                Comment: period.comment,
                Amount: (period.value ? period.value : 0) // convert empty string or null to 0 (decimal)
              })
            period.dirty = false
          }
        })
      })
      const res = await Nomination.saveNominations({ Nominations: regs, SendEmails: this.sendEmails })
      if (!res.failed) {
        this.changes = 0
        this.sendEmails = true // default always send emails - posibility to skip sending when ex. only saving drafts
        this.$root.$message.showSuccess(this.$t('Saved'))
        if (reload) this.loadNominationRegistrations()
      } else {
        // Assume unique key violation
        this.$root.$message.showError(this.$t('Save failed. Please always refresh nominations before save'))
      }
    },
    async loadNominationRegistrations () {
      // Ignore changes
      this.changes = 0

      // Load nomination registrations
      const res = await Nomination.loadNominations({
        Facility: this.facilityNo,
        AgreementId: this.agreementId,
        CustomerNo: this.customerNo,
        WasteFuelType: this.wasteFuelType,
        PlantNo: this.plantNo,
        DateFrom: this.DateFromMonday,
        DateTo: this.DateToSunday,
        ViewType: this.viewType,
        ActiveType: this.activeType,
        StateNo: this.stateNo
      })
      if (!res.failed) this.registrations = res.data

      this.mergeNominationRegistrations()
    },
    async loadAgreements () {
      // Load agreements matching nomination registrations
      const agreeRes = await Nomination.loadAgreementNames({
        Facility: this.facilityNo,
        AgreementId: this.agreementId,
        CustomerNo: this.customerNo,
        WasteFuelType: this.wasteFuelType,
        PlantNo: this.plantNo,
        DateFrom: this.DateFromMonday,
        DateTo: this.DateToSunday,
        ViewType: this.viewType,
        ActiveType: this.activeType,
        StateNo: this.stateNo
      })
      if (!agreeRes.failed) {
        this.agreements = agreeRes.data.map(item => {
          // Grab some of the values just for showing in Agreement filter dropdown
          return {
            Id: item.Id,
            No: item.No,
            Name: item.Name,
            // Count: this.registrations.filter(r => r.AgreementId === item.Id && r.Amount).length,
            SortNo: item.No.padStart(20, '0')
          }
        })
      }
      this.agreements = this.agreements.sort((a, b) => (a.SortNo < b.SortNo) ? -1 : ((b.SortNo < a.SortNo) ? 1 : 0))

      // Add empty agreement filtering, for "no agreement" selected
      if (this.agreements.length) this.agreements.unshift({ Id: guidEmpty, No: '', Name: '' })
    },
    async loadAgreementCustomers () {
      // Load nominations agreements+deliveries customers
      const res = await Nomination.loadAgreementCustomers({
        Facility: this.facilityNo,
        AgreementId: this.agreementId,
        CustomerNo: this.customerNo,
        WasteFuelType: this.wasteFuelType,
        PlantNo: this.plantNo,
        DateFrom: this.DateFromMonday,
        DateTo: this.DateToSunday,
        ViewType: this.viewType,
        ActiveType: this.activeType,
        StateNo: this.stateNo
      })
      if (!res.failed) {
        this.customers = res.data.map(item => {
          // Grab some of the values just for showing in Customers filter dropdown
          return {
            Id: item.Id,
            No: item.No,
            Name: item.Name,
            SortNo: item.No.padStart(20, '0')
          }
        })
      }
      this.customers = this.customers.sort((a, b) => (a.SortNo < b.SortNo) ? -1 : ((b.SortNo < a.SortNo) ? 1 : 0))

      // Add empty customer filtering, for "no customer" selected
      if (this.customers.length) this.customers.unshift({ No: '', Name: '' })
    },
    async loadAgreementPlants () {
      // Load nominations agreements+deliveries plants
      const res = await Nomination.loadAgreementPlants({
        Facility: this.facilityNo,
        AgreementId: this.agreementId,
        CustomerNo: this.customerNo,
        WasteFuelType: this.wasteFuelType,
        PlantNo: this.plantNo,
        DateFrom: this.DateFromMonday,
        DateTo: this.DateToSunday,
        ViewType: this.viewType,
        ActiveType: this.activeType,
        StateNo: this.stateNo
      })
      if (!res.failed) {
        this.plants = res.data.map(item => {
          // Grab some of the values just for showing in Plants filter dropdown
          return {
            Id: item.Id,
            No: item.No,
            Name: item.Name,
            SortNo: item.No.padStart(20, '0')
          }
        })
      }
      this.plants = this.plants.sort((a, b) => (a.SortNo < b.SortNo) ? -1 : ((b.SortNo < a.SortNo) ? 1 : 0))

      // Add empty plant filtering, for "no plant" selected
      if (this.plants.length) this.plants.unshift({ Id: guidEmpty, No: '', Name: '' })
    },
    async loadWasteFuelTypes () {
      // Load nominations agreements+deliveries plants
      const res = await Nomination.loadWasteFuelTypes({ Facility: this.facilityNo })
      if (!res.failed) {
        this.wasteFuelTypes = res.data.map(item => {
          // Grab some of the values just for showing in WasteFuelTypes filter dropdown
          return {
            value: item.No,
            text: item.No + ' ' + item.Name
          }
        })
      }
      // Add empty wasteFuelType filtering, for "no wasteFuelType" selected
      if (this.wasteFuelTypes.length) this.wasteFuelTypes.unshift({ value: '', text: '' })
    },
    mergeNominationRegistrations () {
      this.loading = true
      const dateFrom = this.DateFromMonday
      const dateTo = this.DateToSunday

      var counter = 0
      this.nominations = []
      this.rSums = []
      this.cSums = []

      this.uniqueAgreements.forEach(agreementId => {
        const nominationPeriod = []
        const from = new Date(dateFrom)
        const to = new Date(dateTo + ' 23:59:59.999') // so DateTo is included in comming dateOnly loop
        // loop days between from and to
        for (let day = from; day.valueOf() <= to.valueOf(); day.setDate(day.getDate() + 1)) {
          var dateOnly = new Date(new Date(day).setHours(0, 0, 0, 0)) // Time 00:00:00
          dateOnly = new Date(dateOnly.getTime() - dateOnly.getTimezoneOffset() * 60000) // GMT 00:00:00
          const dateOnlyFormat = moment(dateOnly).format('YYYY-MM-DD')
          // add mon to sun colums for 4 amountTypes
          for (let amountIndex = 0; amountIndex < 4; amountIndex++) {
            const nominationDay = this.registrations.find(r => r.AgreementId === agreementId && r.AmountType === amountIndex && r.DateType === 0 && moment(r.NomDate).format('YYYY-MM-DD') === dateOnlyFormat)
            if (nominationDay) {
              const cleanAmount = nominationDay.Amount === 0 ? '' : nominationDay.Amount
              nominationPeriod.push({ id: nominationDay.Id, amountType: amountIndex, dateType: 0, nomDate: dateOnly, value: cleanAmount, comment: null, dirty: false })
            } else {
              nominationPeriod.push({ id: counter++, amountType: amountIndex, dateType: 0, nomDate: dateOnly, value: null, comment: null, dirty: false })
            }
          }

          // on sundays: add a week colum after sundays for 4 amountTypes including comment
          if (dateOnly.getDay() === 0) {
            for (let amountIndex = 0; amountIndex < 4; amountIndex++) {
              const nominationWeekDay = this.registrations.find(r => r.AgreementId === agreementId && r.AmountType === amountIndex && r.DateType === 1 && moment(r.NomDate).format('YYYY-MM-DD') === dateOnlyFormat)
              if (nominationWeekDay) {
                const cleanAmount = nominationWeekDay.Amount === 0 ? '' : nominationWeekDay.Amount
                nominationPeriod.push({ id: nominationWeekDay.Id, amountType: amountIndex, dateType: 1, nomDate: dateOnly, value: cleanAmount, comment: nominationWeekDay.Comment, dirty: false })
              } else {
                if (amountIndex !== 3) {
                  nominationPeriod.push({ id: counter++, amountType: amountIndex, dateType: 1, nomDate: dateOnly, value: null, comment: null, dirty: false })
                } else {
                  // Add Registrations (amountIndex=3) SUM week on sundays
                  // for regs (amountType=3) in weekdays (dateType=0) ie. the last 7 days => sunday - 6 days = monday
                  let sumThisWeek = 0
                  this.registrations.filter(r => r.AgreementId === agreementId && r.AmountType === 3 && r.DateType === 0 &&
                    moment(r.NomDate).format('YYYY-MM-DD') >= moment(dateOnly).subtract(6, 'days').format('YYYY-MM-DD') &&
                    moment(r.NomDate).format('YYYY-MM-DD') <= moment(dateOnly).format('YYYY-MM-DD')
                  ).forEach(v => { sumThisWeek += v.Amount })
                  nominationPeriod.push({ id: counter++, amountType: amountIndex, dateType: 1, nomDate: dateOnly, value: sumThisWeek > 0 ? sumThisWeek : null, comment: null, dirty: false })
                }
              }
            }
          }

          // Create ONE placeholder for agreement Rows sums (to the right of agreements)
          if (dateOnlyFormat === dateTo) {
            for (let amountIndex = 0; amountIndex < 4; amountIndex++) {
              // Empty value for safety (they are also cleared by calculateSums)
              this.rSums.push({ id: agreementId, amountType: amountIndex, value: null })
            }
          }
        }
        // Add nominationPeriod by agreement id and an agreement number (no) just for sorting correctly by alphanumeric numbers (20 char 0 padded)
        this.nominations.push({ id: agreementId, no: this.agreementNo(agreementId), period: nominationPeriod })

        // Create ONE placeholder for all total Columns sums (below the agreements)
        if (this.cSums.length === 0) {
          // Take a copy of one period for the Colums sums
          const cleared = _.cloneDeep(nominationPeriod)
          // Empty filled values for safety (they are also cleared by calculateSums)
          cleared.filter(c => c.value).forEach(p => { p.value = null })
          this.cSums.push({ id: guidEmpty, period: cleared })
        }
      })

      // Too many fields then switch edit mode off
      this.$nextTick(() => {
        setTimeout(() => {
          // Force calculate row and column sums
          this.calculateSums()

          this.loading = false
          // if loading results in more than (or equals) 50 edit control must be created, just turn off edit mode automatically
          if (this.nominations.length * (moment(this.DateTo).diff(moment(this.DateFrom), 'week') + 1) >= 50) {
            this.editMode = false
          } else {
            // if less than 50 edit controls must be created, just turn edit mode on automatically
            if (this.nominations.length * (moment(this.DateTo).diff(moment(this.DateFrom), 'week') + 1) < 50 && !this.editMode) {
              this.editMode = true
            }
          }
        }, 1)
      })
    },
    rowSum (id, row) {
      // Fetch agreements row sum for current row type
      const rowValues = this.rSums.filter(r => r.id === id && r.amountType === row)
      const result = rowValues && rowValues[0] ? rowValues[0].value : 0
      return result ?? 0
    },
    calculateSums () {
      this.calculateRowsSums()
      this.calculateColumnSums()
    },
    calculateRowsSums () {
      // clear values
      this.rSums.filter(s => s.value).forEach(r => { r.value = null })
      const viewType = Number(this.viewType)
      // loop nominations with value and sum rows
      this.nominations.forEach(n => {
        n.period.filter(p => p.dateType === viewType && p.value > 0).forEach(v => {
          const rSum = this.rSums.filter(r => r.id === n.id && r.amountType === v.amountType)
          if (!rSum[0].value) { rSum[0].value = Number(v.value) } else rSum[0].value += Number(v.value)
        })
      })
    },
    calculateColumnSums () {
      // clear values
      this.cSums.forEach(c => { c.period.filter(p => p.value).forEach(v => { v.value = null }) })
      const viewType = Number(this.viewType)
      // loop nominations with value and sum columns
      this.nominations.forEach(n => {
        n.period.filter(p => p.dateType === viewType && p.value > 0).forEach(v => {
          const cSum = this.cSums[0].period.filter(c => c.dateType === viewType && c.amountType === v.amountType && DateUtil.getDateTimeYMD(c.nomDate) === DateUtil.getDateTimeYMD(v.nomDate))
          if (!cSum[0].value) { cSum[0].value = Number(v.value) } else cSum[0].value += Number(v.value)
        })
      })
    },
    isDayNo (dayNo, val) {
      return moment(val).day() === dayNo // 0=sun, 1=mon,..,6=sat
    },
    calculateMondaySunday () {
      this.DateFromMonday = moment(this.DateFrom).subtract(moment(this.DateFrom).day() === 0 ? 6 : moment(this.DateFrom).day() - 1, 'days').format('YYYY-MM-DD')
      this.DateToSunday = moment(this.DateTo).add(moment(this.DateTo).day() === 0 ? 0 : 7 - moment(this.DateTo).day(), 'days').format('YYYY-MM-DD')
    }
  },
  watch: {
    DateFrom: {
      async handler () {
        // auto add daysInPeriod to DateTo if DateFrom is after current
        if (this.DateFrom > this.DateTo) this.DateTo = moment(this.DateFrom).add(daysInPeriod - 1, 'days').format('YYYY-MM-DD')

        this.calculateMondaySunday()
      }
    },
    DateTo: {
      async handler () {
        // auto substract daysInPeriod to DateFrom if DateTo is before current
        if (this.DateTo < this.DateFrom) this.DateFrom = moment(this.DateTo).subtract(daysInPeriod, 'days').format('YYYY-MM-DD')

        this.calculateMondaySunday()
      }
    }
  },
  async mounted () {
    var noValue = user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    // if user, hide accept response button and disable requested fields
    this.isCustomer = user.userDetails.find(d => d.Name === 'CustomerNo')?.Value ?? false

    // Load Facilities
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }
    // Set filter facilityNo from LocalStorage
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
    this.calculateMondaySunday()

    // First time just load filter agreements incl. all other filters
    await this.loadAgreements()
    await this.loadAgreementCustomers()
    await this.loadAgreementPlants()
    await this.loadWasteFuelTypes()

    // Set filter agreementId from LocalStorage
    const storedAgreementId = LocalStorage.load('agreementId')
    if (storedAgreementId && this.agreements.some(a => a.Id === storedAgreementId)) this.agreementId = storedAgreementId
    else {
      this.agreementId = guidEmpty
      LocalStorage.remove('agreementId')
    }
    // Set filter customerNo from LocalStorage
    const storedCustomerNo = LocalStorage.load('customerNo')?.toString() ?? ''
    if (storedCustomerNo && this.customers.some(a => a.No === storedCustomerNo)) this.customerNo = storedCustomerNo
    else {
      this.customerNo = ''
      LocalStorage.remove('customerNo')
    }
    // Set filter wasteFuelType from LocalStorage
    const storedWasteFuelType = LocalStorage.load('wasteFuelType')?.toString() ?? ''
    if (storedWasteFuelType && this.wasteFuelTypes.some(a => a.value === storedWasteFuelType)) this.wasteFuelType = storedWasteFuelType
    else {
      this.wasteFuelType = ''
      LocalStorage.remove('wasteFuelType')
    }
    // Set filter plantNo from LocalStorage
    const storedPlantNo = LocalStorage.load('plantNo')?.toString() ?? ''
    if (storedPlantNo && this.plants.some(a => a.No === storedPlantNo)) this.plantNo = storedPlantNo
    else {
      this.plantNo = ''
      LocalStorage.remove('plantNo')
    }
    // Set filter stateNo from LocalStorage
    const storedStateNo = LocalStorage.load('stateNo')?.toString() ?? ''
    if (storedStateNo && this.states.some(a => a.value === storedStateNo)) this.stateNo = storedStateNo
    else {
      this.stateNo = ''
      LocalStorage.remove('stateNo')
    }
  }
}
</script>

<style>

/* styling around day fields - light blue with a little glow is nice */
.amount-field {
    padding: 0px 0px 0px 5px;
    border:1px solid #719ECE;
    box-shadow: 0 0 3px #719ECE;
}

/* styling around week fields - black to divide weeks better */
.amount-field-week {
    padding: 0px 0px 0px 5px;
    border:1px solid black;
    box-shadow: 0 0 3px grey;
}

/* color for Agreed edit fields */
.my-green .v-text-field__slot input {
   color: green !important;
}

/* color for Requested and Response edit fields */
.my-red .v-text-field__slot input {
   color: red !important;
}

/* color for Delivered edit fields */
.my-black .v-text-field__slot input {
   color: black !important;
}

/* for reducing table cells with and margins */
.my-td {
  padding: 6px !important;
  min-width: 56px;
  font: 14px;
}

/* fixes bad drawing issue with Log headers */
.v-data-table-header th {
  white-space: nowrap;
}

/* for adjusting edit and comment fields */
.value-div { text-align: center }
.comment-div { padding:0px 6px 0px 6px; box-shadow:0px 0px 0px 1px black inset; overflow-wrap: break-word }

</style>
